export const STATUS_VARIABLE = [
  "New",
  "Shipped",
  "Partly Shipped",
  "Partly Allocated",
  "Canceled",
  "Allocated",
];

// export const COMPANY_DETAILS = {
//   name: "FLEX KNITS FACTORIES INC.",
//   agent: "Rogers Capital Corporate Services Ltd",
//   address:
//     "3rd FLOOR ROGERS HOUSE, N°. 5 PRESIDENT JOHN KENNEDY, Port Louis, MAURITUS",
//   contact: "Direct: +261 20 23 37863 / Fax: +261 20 23 691 46",
// };

export enum TABLE_NAME {
  accTable = "accTable",
  ypoTable = "ypoTable",
  apoTable = "apoTable",
  orderSheet = "orderSheet",
  orderStyle = "orderStyle",
  lsppoTable = "lsppoTable",
  booking = "Booking",
  pdmsTable = "pdmsTable",
  returnHistory = "returnHistory",
  fcdYarnDyeTable = "fcd_yarn_dye_table",
  yarnAllocation = 'yarnAllocation'
}

export enum ORDER_TYPE {
  indentOrder = 3,
  preOrder = 1,
  generalORder = 2,
}

export const expirtation_table_state=60000;
